// import React, { useState } from "react";
// import NavBar from "../components/Navbar/NavBar";
// import Footer from "../components/Footer";
// import { useDocTitle } from "../components/CustomHook";
// import axios from "axios";
// // import emailjs from 'emailjs-com';
// import Notiflix from "notiflix";

// const DemoProduct = (props) => {
//   useDocTitle("SKYLAND WEB | Molad e Konsult - Demo our products");

//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [email, setEmail] = useState("");
//   const [phone, setPhone] = useState("");
//   const [message, setMessage] = useState("");
//   const [demoProducts, setDemoProducts] = useState([]);
//   const [errors, setErrors] = useState([]);

//   const handleChange = (e) => {
//     const value = e.target.value;
//     const checked = e.target.checked;
//     errors.products = [];
//     if (checked) {
//       setDemoProducts([...demoProducts, value]);
//     } else {
//       setDemoProducts(demoProducts.filter((e) => e !== value));
//     }
//   };
//   const clearErrors = () => {
//     setErrors([]);
//   };

//   const clearInput = () => {
//     setFirstName("");
//     setLastName("");
//     setEmail("");
//     setPhone("");
//     setMessage("");
//   };

//   function sendEmail(e) {
//     e.preventDefault();
//     document.getElementById("submitBtn").disabled = true;
//     document.getElementById("submitBtn").innerHTML = "Loading...";
//     let fData = new FormData();
//     fData.append("first_name", firstName);
//     fData.append("last_name", lastName);
//     fData.append("email", email);
//     fData.append("phone_number", phone);
//     fData.append("message", message);
//     fData.append("products", demoProducts);

//     // emailjs.sendForm('service_7uy4ojg', 'template_et9wvdg', e.target, 'user_uE0bSPGbhRTmAF3I2fd3s')
//     //   .then((result) => {
//     //       console.log(result.text);
//     //       Notiflix.Report.success(
//     //         'Success',
//     //         '"Thanks for sending a message, we\'ll be in touch soon."',
//     //         'Okay',
//     //         );
//     //   }, (error) => {
//     //       console.log(error.text);
//     //       Notiflix.Report.failure(
//     //         'An error occured',
//     //         'Please try sending the message again.',
//     //         'Okay',
//     //         );
//     //   });

//     axios({
//       method: "post",
//       url: process.env.REACT_APP_DEMO_REQUEST_API,
//       data: fData,
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     })
//       .then(function (response) {
//         document.getElementById("submitBtn").disabled = false;
//         document.getElementById("submitBtn").innerHTML = "send message";
//         clearInput();
//         //handle success
//         Notiflix.Report.success("Success", response.data.message, "Okay");
//       })
//       .catch(function (error) {
//         document.getElementById("submitBtn").disabled = false;
//         document.getElementById("submitBtn").innerHTML = "send message";
//         //handle error
//         const { response } = error;
//         if (response.status === 500) {
//           Notiflix.Report.failure(
//             "An error occurred",
//             response.data.message,
//             "Okay"
//           );
//         }
//         if (response.data.errors !== null) {
//           setErrors(response.data.errors);
//         }
//       });
//   }

// import React, { useState } from "react";
// import NavBar from "../components/Navbar/NavBar";
// import Footer from "../components/Footer";
// import { useDocTitle } from "../components/CustomHook";
// import Notiflix from "notiflix";
// import emailjs from "emailjs-com";
// import axios from "axios";
// import whatsapp from '../images/whatsapp-svgrepo-com.svg'
// const DemoProduct = (props) => {
//     useDocTitle("SKYLAND WEB | Molad e Konsult - Demo our products");

//     const [firstName, setFirstName] = useState("");
//     const [lastName, setLastName] = useState("");
//     const [email, setEmail] = useState("");
//     const [phone, setPhone] = useState("");
//     const [message, setMessage] = useState("");
//     const [demoProducts, setDemoProducts] = useState([]);
//     const [errors, setErrors] = useState([]);

//     const handleChange = (e) => {
//         const value = e.target.value;
//         const checked = e.target.checked;
//         errors.products = [];
//         if (checked) {
//             setDemoProducts([...demoProducts, value]);
//         } else {
//             setDemoProducts(demoProducts.filter((e) => e !== value));
//         }
//     };

//     const clearErrors = () => {
//         setErrors([]);
//     };

//     const clearInput = () => {
//         setFirstName("");
//         setLastName("");
//         setEmail("");
//         setPhone("");
//         setMessage("");
//     };

//     function sendEmail(e) {
//         e.preventDefault();

//         // Perform form validation
//         if (!firstName || !lastName || !email || !phone || !message || demoProducts.length === 0) {
//             Notiflix.Report.failure(
//                 "Validation Error",
//                 "Please fill in all required fields and select at least one product.",
//                 "Okay"
//             );
//             return;
//         }

//         document.getElementById("submitBtn").disabled = true;
//         document.getElementById("submitBtn").innerHTML = "Loading...";

//         const templateParams = {
//             from_name: `${firstName} ${lastName}`,
//             from_email: email,
//             phone_number: phone,
//             message: message,
//             products: demoProducts.join(", "), // Convert array to string
//         };

//         const serviceId = 'service_1knfku9';
//         const templateId = 'template_l3wspa8';
//         const userId = 'iWF8xbb9Wc4LQS11v';

//         emailjs.send(serviceId, templateId, templateParams, userId)
//             .then((response) => {
//                 document.getElementById("submitBtn").disabled = false;
//                 document.getElementById("submitBtn").innerHTML = "Send Message";
//                 clearInput();
//                 Notiflix.Report.success(
//                     "Success",
//                     "Your message has been sent successfully!",
//                     "Okay"
//                 );
//             })
//             .catch((error) => {
//                 document.getElementById("submitBtn").disabled = false;
//                 document.getElementById("submitBtn").innerHTML = "Send Message";
//                 Notiflix.Report.failure(
//                     "An error occurred",
//                     "Your message could not be sent. Please try again later.",
//                     "Okay"
//                 );
//             });
//     }


//     return (
//         <>
//             <div>
//                 <NavBar />
//             </div>
//             <div
//                 id="demo"
//                 className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24"
//             >
//                 <div
//                     className="container mx-auto my-8 px-4 lg:px-20"
//                     data-aos="zoom-in"
//                 >
//                     <form onSubmit={sendEmail} id="demoProductForm">
//                         <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
//                             <div className="flex">
//                                 <h1 className="font-bold text-center lg:text-left text-blue-900 uppercase text-4xl">
//                                     Demo our products
//                                 </h1>
//                             </div>
//                             <div className="flex items-center my-4">
//                                 <input
//                                     id="checkbox-1"
//                                     aria-describedby="checkbox-1"
//                                     type="checkbox"
//                                     className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
//                                     value="business_management_system"
//                                     onChange={handleChange}
//                                 />
//                                 <label
//                                     htmlFor="checkbox-1"
//                                     className="ml-3 text-lg font-medium text-gray-900"
//                                 >
//                                     Business Management System
//                                 </label>
//                             </div>
//                             <div className="flex items-center my-4">
//                                 <input
//                                     id="checkbox-1"
//                                     aria-describedby="checkbox-1"
//                                     type="checkbox"
//                                     className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
//                                     value="school_management_portal"
//                                     onChange={handleChange}
//                                 />
//                                 <label
//                                     htmlFor="checkbox-1"
//                                     className="ml-3 text-lg font-medium text-gray-900"
//                                 >
//                                     School Management Portal
//                                 </label>
//                             </div>
//                             <div className="flex items-center my-4">
//                                 <input
//                                     id="checkbox-1"
//                                     aria-describedby="checkbox-1"
//                                     type="checkbox"
//                                     className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
//                                     value="payroll_management_system"
//                                     onChange={handleChange}
//                                 />
//                                 <label
//                                     htmlFor="checkbox-1"
//                                     className="ml-3 text-lg font-medium text-gray-900"
//                                 >
//                                     Payroll Management System
//                                 </label>
//                             </div>
//                             <div className="flex items-center my-4">
//                                 <input
//                                     id="checkbox-1"
//                                     aria-describedby="checkbox-1"
//                                     type="checkbox"
//                                     className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
//                                     value="event_management_system"
//                                     onChange={handleChange}
//                                 />
//                                 <label
//                                     htmlFor="checkbox-1"
//                                     className="ml-3 text-lg font-medium text-gray-900"
//                                 >
//                                     Event Management System
//                                 </label>
//                             </div>
//                             {errors && (
//                                 <p className="text-red-500 text-sm">{errors.products}</p>
//                             )}

//                             <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
//                                 <div>
//                                     <input
//                                         name="first_name"
//                                         className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
//                                         type="text"
//                                         placeholder="First Name*"
//                                         value={firstName}
//                                         onChange={(e) => setFirstName(e.target.value)}
//                                         onKeyUp={clearErrors}
//                                     />
//                                     {errors && (
//                                         <p className="text-red-500 text-sm">{errors.first_name}</p>
//                                     )}
//                                 </div>

//                                 <div>
//                                     <input
//                                         name="last_name"
//                                         className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
//                                         type="text"
//                                         placeholder="Last Name*"
//                                         value={lastName}
//                                         onChange={(e) => setLastName(e.target.value)}
//                                         onKeyUp={clearErrors}
//                                     />
//                                     {errors && (
//                                         <p className="text-red-500 text-sm">{errors.last_name}</p>
//                                     )}
//                                 </div>

//                                 <div>
//                                     <input
//                                         name="email"
//                                         className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
//                                         type="email"
//                                         placeholder="Email*"
//                                         value={email}
//                                         onChange={(e) => setEmail(e.target.value)}
//                                         onKeyUp={clearErrors}
//                                     />
//                                     {errors && (
//                                         <p className="text-red-500 text-sm">{errors.email}</p>
//                                     )}
//                                 </div>

//                                 <div>
//                                     <input
//                                         name="phone_number"
//                                         className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
//                                         type="number"
//                                         placeholder="Phone*"
//                                         value={phone}
//                                         onChange={(e) => setPhone(e.target.value)}
//                                         onKeyUp={clearErrors}
//                                     />
//                                     {errors && (
//                                         <p className="text-red-500 text-sm">
//                                             {errors.phone_number}
//                                         </p>
//                                     )}
//                                 </div>
//                             </div>
//                             <div className="my-4">
//                                 <textarea
//                                     name="message"
//                                     placeholder="Message*"
//                                     className="w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
//                                     value={message}
//                                     onChange={(e) => setMessage(e.target.value)}
//                                     onKeyUp={clearErrors}
//                                 ></textarea>
//                                 {errors && (
//                                     <p className="text-red-500 text-sm">{errors.message}</p>
//                                 )}
//                             </div>
//                             <div className="my-2 w-1/2 lg:w-2/4">
//                                 <button
//                                     type="submit"
//                                     id="submitBtn"
//                                     className="uppercase text-sm font-bold tracking-wide bg-gray-500 hover:bg-blue-900 text-gray-100 p-3 rounded-lg w-full 
//                                     focus:outline-none focus:shadow-outline"
//                                 >
//                                     Send Message
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                     <div className="w-full  lg:-mt-96 lg:w-2/6 px-8 py-6 ml-auto bg-blue-900 rounded-2xl">
//                         <div className="flex flex-col text-white">
//                             <div className="flex my-4 w-2/3 lg:w-3/4">
//                                 <div className="flex flex-col">
//                                     <i className="fas fa-map-marker-alt pt-2 pr-2" />
//                                 </div>
//                                 <div className="flex flex-col">
//                                     <h2 className="text-2xl">Office Address</h2>
//                                     <p className="text-gray-400">9717 105TH ST 2ND FLR OZONE PARK NY, 11416</p>
//                                 </div>
//                             </div>

//                             <div className="flex my-4 w-2/3 lg:w-1/2">
//                                 <div className="flex flex-col">
//                                     <i className="fas fa-phone-alt pt-2 pr-2" />
//                                 </div>

//                                 <div className="flex flex-col">
//                                     <h2 className="text-2xl">Call Us</h2>
//                                     <p className="text-gray-400">Tel: 01742916158</p>

//                                     <div className="mt-5">
//                                         <h2 className="text-2xl">Send an E-mail</h2>
//                                         <p className="text-gray-400">info@skylandweb.com</p>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="flex my-4 w-2/3 lg:w-1/2">
//                                 <a
//                                     href="https://www.facebook.com/profile.php?id=61557557632598"
//                                     target="_blank"
//                                     rel="noreferrer"
//                                     className="rounded-full flex justify-center bg-white h-8 text-blue-900  w-8 mx-1 text-center pt-1"
//                                 >
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         className="fill-current font-black hover:animate-pulse"
//                                     >
//                                         <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path>
//                                     </svg>
//                                 </a>
//                                 <a
//                                     href="https://www.linkedin.com/company/skyland-web/mycompany/"
//                                     target="_blank"
//                                     rel="noreferrer"
//                                     className="rounded-full flex justify-center bg-white h-8 text-blue-900  w-8 mx-1 text-center pt-1"
//                                 >
//                                     <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         className="fill-current font-black hover:animate-pulse"
//                                     >
//                                         <circle cx="4.983" cy="5.009" r="2.188"></circle>
//                                         <path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path>
//                                     </svg>
//                                 </a>
//                                 <a href="https://wa.me/01742916158" target="_blank" rel="noreferrer" className="rounded-full flex justify-center bg-white h-8 text-blue-900  w-8  mx-1 text-center pt-1">
//                                     <img src={whatsapp} alt='icon' />
//                                 </a>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     );
// };

// export default DemoProduct;

import React, { useState } from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import Notiflix from "notiflix";
import axios from "axios";
import whatsapp from '../images/whatsapp-svgrepo-com.svg';
import { FaSchool, FaUserGraduate, FaChalkboardTeacher, FaClinicMedical, FaNotesMedical, FaCalendarAlt } from "react-icons/fa";

const DemoProduct = (props) => {
    useDocTitle("SKYLAND WEB | Demo Our Products");

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        demoProducts: [],
        organizationType: ""
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const productCategories = [
        {
            name: "Education Solutions",
            icon: <FaSchool className="text-blue-600 text-xl mr-2" />,
            products: [
                {
                    id: "school_erp",
                    name: "School ERP System",
                    description: "Comprehensive management for private schools including admissions, academics, and finance"
                },
                {
                    id: "student_portal",
                    name: "Student Portal",
                    description: "Interactive platform for students with grade tracking and resource access"
                },
                {
                    id: "learning_management",
                    name: "Learning Management System",
                    description: "Complete e-learning solution with course management and virtual classrooms"
                }
            ]
        },
        {
            name: "Healthcare Solutions",
            icon: <FaClinicMedical className="text-green-600 text-xl mr-2" />,
            products: [
                {
                    id: "clinic_management",
                    name: "Clinic Management System",
                    description: "End-to-end solution for doctor's offices and small clinics"
                },
                {
                    id: "ehr_system",
                    name: "Electronic Health Records",
                    description: "Secure digital patient records with appointment scheduling"
                },
                {
                    id: "telemedicine",
                    name: "Telemedicine Platform",
                    description: "Virtual consultations and remote patient monitoring"
                }
            ]
        },
        {
            name: "Business Solutions",
            icon: <FaCalendarAlt className="text-purple-600 text-xl mr-2" />,
            products: [
                {
                    id: "business_management",
                    name: "Business Management System",
                    description: "Complete solution for business operations and workflow"
                },
                {
                    id: "payroll_system",
                    name: "Payroll Management",
                    description: "Automated payroll processing and employee management"
                },
                {
                    id: "event_management",
                    name: "Event Management System",
                    description: "Planning and execution platform for events"
                }
            ]
        }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleProductSelect = (productId) => {
        setFormData(prev => {
            const products = [...prev.demoProducts];
            const index = products.indexOf(productId);
            
            if (index === -1) {
                products.push(productId);
            } else {
                products.splice(index, 1);
            }
            
            return { ...prev, demoProducts: products };
        });
    };

    const sendEmail = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        // Validate form
        const newErrors = {};
        if (!formData.firstName) newErrors.firstName = "First name is required";
        if (!formData.lastName) newErrors.lastName = "Last name is required";
        if (!formData.email) newErrors.email = "Email is required";
        if (!formData.phone) newErrors.phone = "Phone number is required";
        if (formData.demoProducts.length === 0) newErrors.demoProducts = "Please select at least one product";
        
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsSubmitting(false);
            Notiflix.Notify.failure("Please fill all required fields");
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/demo-requests`, {
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                organizationType: formData.organizationType,
                message: formData.message,
                demoProducts: formData.demoProducts,
            });

            Notiflix.Notify.success("Request submitted successfully!");
            setFormData({
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                message: "",
                demoProducts: [],
                organizationType: ""
            });
        } catch (error) {
            Notiflix.Notify.failure("Failed to submit request. Please try again.");
            console.error("Email sending error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <NavBar />
            
            <div id="demo" className="bg-gray-50 py-12 lg:py-16 mt-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                            Demo Our <span className="text-blue-600">Solutions</span>
                        </h1>
                        <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Experience how our specialized solutions can transform your organization
                        </p>
                    </div>

                    <div className="flex flex-col lg:flex-row gap-8">
                        <div className="w-full lg:w-2/3 bg-white rounded-xl shadow-lg overflow-hidden">
                            <form onSubmit={sendEmail} className="p-8">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                    <div>
                                        <label className="block text-gray-700 mb-2">First Name*</label>
                                        <input
                                            name="firstName"
                                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                        />
                                        {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
                                    </div>
                                    <div>
                                        <label className="block text-gray-700 mb-2">Last Name*</label>
                                        <input
                                            name="lastName"
                                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                        />
                                        {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                    <div>
                                        <label className="block text-gray-700 mb-2">Email*</label>
                                        <input
                                            name="email"
                                            type="email"
                                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                                    </div>
                                    <div>
                                        <label className="block text-gray-700 mb-2">Phone*</label>
                                        <input
                                            name="phone"
                                            type="tel"
                                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={formData.phone}
                                            onChange={handleChange}
                                        />
                                        {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
                                    </div>
                                </div>

                                <div className="mb-6">
                                    <label className="block text-gray-700 mb-2">Organization Type</label>
                                    <select
                                        name="organizationType"
                                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={formData.organizationType}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select your organization type</option>
                                        <option value="school">School/Educational Institution</option>
                                        <option value="healthcare">Healthcare Facility/Clinic</option>
                                        <option value="business">Business/Corporate</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                <div className="mb-6">
                                    <label className="block text-gray-700 mb-4">Select Solutions to Demo*</label>
                                    
                                    {productCategories.map((category) => (
                                        <div key={category.name} className="mb-6">
                                            <div className="flex items-center mb-3">
                                                {category.icon}
                                                <h3 className="font-semibold text-lg">{category.name}</h3>
                                            </div>
                                            
                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                {category.products.map((product) => (
                                                    <div 
                                                        key={product.id}
                                                        className={`p-4 border rounded-lg cursor-pointer transition-all ${formData.demoProducts.includes(product.id) ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`}
                                                        onClick={() => handleProductSelect(product.id)}
                                                    >
                                                        <div className="flex items-start">
                                                            <input
                                                                type="checkbox"
                                                                id={product.id}
                                                                checked={formData.demoProducts.includes(product.id)}
                                                                onChange={() => handleProductSelect(product.id)}
                                                                className="mt-1 mr-2"
                                                            />
                                                            <div>
                                                                <label htmlFor={product.id} className="font-medium text-gray-800 cursor-pointer">
                                                                    {product.name}
                                                                </label>
                                                                <p className="text-sm text-gray-600 mt-1">{product.description}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                    
                                    {errors.demoProducts && <p className="text-red-500 text-sm mt-1">{errors.demoProducts}</p>}
                                </div>

                                <div className="mb-6">
                                    <label className="block text-gray-700 mb-2">Additional Information</label>
                                    <textarea
                                        name="message"
                                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 h-32"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Tell us about your specific needs..."
                                    ></textarea>
                                </div>

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-all ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Request Demo'}
                                </button>
                            </form>
                        </div>

                        <div className="w-full lg:w-1/3">
                            <div className="bg-blue-900 text-white rounded-xl shadow-lg overflow-hidden">
                                <div className="p-8">
                                    <h2 className="text-2xl font-bold mb-6">Why Demo Our Solutions?</h2>
                                    
                                    <div className="space-y-6">
                                        <div className="flex items-start">
                                            <div className="bg-blue-700 p-2 rounded-full mr-4">
                                                <FaUserGraduate className="text-white" />
                                            </div>
                                            <div>
                                                <h3 className="font-semibold">For Schools</h3>
                                                <p className="text-blue-200 mt-1">
                                                    See how our education solutions can streamline administration, enhance learning, and improve communication.
                                                </p>
                                            </div>
                                        </div>
                                        
                                        <div className="flex items-start">
                                            <div className="bg-green-600 p-2 rounded-full mr-4">
                                                <FaNotesMedical className="text-white" />
                                            </div>
                                            <div>
                                                <h3 className="font-semibold">For Healthcare</h3>
                                                <p className="text-blue-200 mt-1">
                                                    Discover how our clinic management systems can optimize patient care and practice operations.
                                                </p>
                                            </div>
                                        </div>
                                        
                                        <div className="flex items-start">
                                            <div className="bg-purple-600 p-2 rounded-full mr-4">
                                                <FaChalkboardTeacher className="text-white" />
                                            </div>
                                            <div>
                                                <h3 className="font-semibold">What to Expect</h3>
                                                <p className="text-blue-200 mt-1">
                                                    A personalized 30-minute walkthrough of the solutions you select, with time for Q&A.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="mt-8 pt-6 border-t border-blue-800">
                                        <h3 className="font-semibold mb-3">Contact Information</h3>
                                        <p className="text-blue-200 mb-2">
                                            <span className="font-medium">Email:</span> info@skylandweb.com
                                        </p>
                                        <p className="text-blue-200 mb-2">
                                            <span className="font-medium">Phone:</span> +13478151556
                                        </p>
                                        <p className="text-blue-200">
                                            <span className="font-medium">Address:</span> 9717 105TH ST 2ND FLR, OZONE PARK NY, 11416
                                        </p>
                                        
                                        <div className="flex mt-4 space-x-3">
                                            <a href="https://www.facebook.com/profile.php?id=61557557632598" target="_blank" rel="noopener noreferrer" className="bg-white text-blue-900 p-2 rounded-full hover:bg-blue-100 transition-colors">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="fill-current">
                                                    <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path>
                                                </svg>
                                            </a>
                                            <a href="https://www.linkedin.com/company/skyland-web/mycompany/" target="_blank" rel="noopener noreferrer" className="bg-white text-blue-900 p-2 rounded-full hover:bg-blue-100 transition-colors">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" className="fill-current">
                                                    <circle cx="4.983" cy="5.009" r="2.188"></circle>
                                                    <path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path>
                                                </svg>
                                            </a>
                                            <a href="https://wa.me/01742916158" target="_blank" rel="noopener noreferrer" className="bg-white text-blue-900 p-2 rounded-full hover:bg-blue-100 transition-colors">
                                                <img src={whatsapp} alt="WhatsApp" className="w-5 h-5" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer />
        </>
    );
};

export default DemoProduct;